import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccordion, LazyAlert, LazyAnchorButtons, LazyAnchorSections, LazyBackground, LazyBestBuyBanner, LazyComponentTest, LazyContainerWrapper, LazyContentTypes, LazyFormSelector, LazyInfoBlock, LazyInfoBlockCta, LazyLinkRef, LazyLinksGrid, LazyLogosGrid, LazyMedia, LazyOffers, LazyOffersBlock, LazyPageTitle, LazySearchTable, LazySiloSections, LazySimpleTable, LazySlider, LazySubscribeBlok, LazySubtitle, LazyVideoBanner, LazyVideoHeroBanner, LazyWysiwyg, LazyTestData, LazyClpBanner, LazyClpEndedBanner, LazyClpInfluencerBlock, LazySiloItemLarge, LazySiloItemMedium, LazySiloItemSmall, LazyHeaderI18n, LazyHeaderLink, LazyHeaderOffers, LazyHeaderProfile, LazyHeaderSearch, LazyClp, LazyPage, LazyPageTypeTypes, LazySilo, LazyClpUpload, LazyNote, LazySidebarLinks, LazyTestimonialSlider, LazyCookiebotWidget, LazySherpaMapWidget, LazySherpaWidget, LazySixtWidget, LazyBaseSection, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["Accordion", LazyAccordion],
["Alert", LazyAlert],
["AnchorButtons", LazyAnchorButtons],
["AnchorSections", LazyAnchorSections],
["Background", LazyBackground],
["BestBuyBanner", LazyBestBuyBanner],
["ComponentTest", LazyComponentTest],
["ContainerWrapper", LazyContainerWrapper],
["ContentTypes", LazyContentTypes],
["FormSelector", LazyFormSelector],
["InfoBlock", LazyInfoBlock],
["InfoBlockCta", LazyInfoBlockCta],
["LinkRef", LazyLinkRef],
["LinksGrid", LazyLinksGrid],
["LogosGrid", LazyLogosGrid],
["Media", LazyMedia],
["Offers", LazyOffers],
["OffersBlock", LazyOffersBlock],
["PageTitle", LazyPageTitle],
["SearchTable", LazySearchTable],
["SiloSections", LazySiloSections],
["SimpleTable", LazySimpleTable],
["Slider", LazySlider],
["SubscribeBlok", LazySubscribeBlok],
["Subtitle", LazySubtitle],
["VideoBanner", LazyVideoBanner],
["VideoHeroBanner", LazyVideoHeroBanner],
["Wysiwyg", LazyWysiwyg],
["TestData", LazyTestData],
["ClpBanner", LazyClpBanner],
["ClpEndedBanner", LazyClpEndedBanner],
["ClpInfluencerBlock", LazyClpInfluencerBlock],
["SiloItemLarge", LazySiloItemLarge],
["SiloItemMedium", LazySiloItemMedium],
["SiloItemSmall", LazySiloItemSmall],
["HeaderI18n", LazyHeaderI18n],
["HeaderLink", LazyHeaderLink],
["HeaderOffers", LazyHeaderOffers],
["HeaderProfile", LazyHeaderProfile],
["HeaderSearch", LazyHeaderSearch],
["Clp", LazyClp],
["Page", LazyPage],
["PageTypeTypes", LazyPageTypeTypes],
["Silo", LazySilo],
["ClpUpload", LazyClpUpload],
["Note", LazyNote],
["SidebarLinks", LazySidebarLinks],
["TestimonialSlider", LazyTestimonialSlider],
["CookiebotWidget", LazyCookiebotWidget],
["SherpaMapWidget", LazySherpaMapWidget],
["SherpaWidget", LazySherpaWidget],
["SixtWidget", LazySixtWidget],
["BaseSection", LazyBaseSection],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
